// extracted by mini-css-extract-plugin
module.exports = {"Portada":"Portada_Portada__3bcIo","Image":"Portada_Image__2xki7","Title":"Portada_Title__1RSJ8"};